import script from "./SalesReportNewTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesReportNewTable.vue?vue&type=script&setup=true&lang=ts"

import "./SalesReportNewTable.vue?vue&type=style&index=0&id=71e25d22&lang=scss"

const __exports__ = script;

export default __exports__